// base url
export const clientUrl = 'https://secure.caica.co.tz/api';

// authentication api routes
export const USER_LOGIN = '/managers/login';
export const GET_USER_PROFILE = '/user';

// branches api routes
export const GET_BRANCHES = '/branches';
export const GET_SINGLE_BRANCH = '/branches/';
export const GET_BRANCH_PRODUCTS = '/managers/products/branch/';
export const CREATE_BRANCH = '/branches';
export const ACTIVATE_BRANCH = '/branches/activate';
export const DEACTIVATE_BRANCH = '/branches/deactivate';

// products api routes
export const GET_PRODUCTS = '/managers/products';
export const ACTIVATE_PRODUCT = '/managers/products/activate/';
export const PRODUCT_SIZES = '/managers/products/size/';
export const PRODUCT_IMAGES = '/managers/products/images/';
export const SET_PRODUCT_ON_SELL = '/managers/products/set-on-sell/';
export const GET_PRODUCT_BY_PROMOTION = '/managers/products/promotions/';
export const DELETE_PRODUCT = '/managers/products';

// promotions api routes
export const GET_PROMOTIONS = '/promotions';
export const GET_SINGLE_PROMOTIONS = '/promotions/';
export const ACTIVATE_PROMOTION = '/promotions/activate/';
export const DEACTIVATE_PROMOTION = '/promotions/deactivate/';

// orders api routes
export const GET_ORDERS = '/orders';
export const GET_SINGLE_ORDER = '/orders/';
export const DELIVER_ORDER = '/orders/delivery/';
export const SHIP_ORDER = '/orders/ship/';

// brands api routes
export const GET_BRANDS = '/brands';
export const GET_SINGLE_BRAND = '/brands/';
export const GET_BRAND_PRODUCTS = '/managers/products/brand/';

// categories api routes
export const CREATE_CATEGORY = '/categories/';
export const GET_CATEGORIES = '/categories';
export const GET_SUB_CATEGORIES = '/categories';
export const GET_ALL_SUB_CATEGORIES = '/sub-categories';

// customers api routes
export const GET_ALL_CUSTOMERS = '/customers';
export const GET_SINGLE_CUSTOMER = '/customers/';
export const GET_CUSTOMER_ORDERS = '/orders/customers/';

// managers api routes
export const GET_ALL_MANAGERS = '/managers';
